import React from "react";
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";

const styles = theme => ({
  dialogTitleOverride: {
    backgroundColor: "#838383",
    color: "#fff",
    "& *": {
      color: "#fff"
    }
  }
});

class OSSActionDialog extends React.Component {
  render() {
    const {
      classes,
      open,
      title,
      titleStyle,
      children,
      classOverrides = {},
      maxWidth = "md",
      ...rest
    } = this.props;

    return (
      <Dialog
        open={open}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby={`${title} Dialog`}
        classes={classOverrides}
        maxWidth={maxWidth}
        {...rest}
      >
        {title && (
          <DialogTitle
            classes={{
              root: titleStyle ? titleStyle : classes.dialogTitleOverride
            }}
            disableTypography={Boolean(titleStyle)}
          >
            {title}
          </DialogTitle>
        )}
        {children}
      </Dialog>
    );
  }
}

OSSActionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.any.isRequired
};

OSSActionDialog.defaultProps = {};

export default withStyles(styles)(OSSActionDialog);
